import { useCallback, useState } from "react";

export default function useGetFinancialPOATemplate() {
  const [isLoadingFinancialPOATemplate, setIsLoadingFinancialPOATemplate] =
    useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchFinancialPOA = useCallback(
    async (trustId: string, trustName: string) => {
      let url = `https://hometrustapi.azurewebsites.net/api/v2/Templates/generate/FinancialPOA/${trustId}`;

      setIsLoadingFinancialPOATemplate(true);
      setError(null);

      console.log("getting Templates");
      try {
        await fetch(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          method: "GET",
        })
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${trustName}_Financial POA.docx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          })
          .catch((error) => console.error("Error downloading file:", error));
      } catch (error: any) {
        setError(error);
        setIsLoadingFinancialPOATemplate(false);
      }
    },
    [],
  );

  return { isLoadingFinancialPOATemplate, error, fetchFinancialPOA };
}
